<template>
  <div class="row py-3 mx-0 bg-secondary-3 rounded">
    <div class="col-md-12">
      <div class="row ml-4">
        <div class="col-sm-6 col-md-3 pb-3">
          <span class="color-gray font-weight-normal font-14">{{ personnelNameTitle }}</span>
          <div class="color-dark font-weight-normal font-16">
            {{ data.personnelName }}
          </div>
        </div>
        <div v-if="isAssistance || isMaster" class="col-sm-6 col-md-2 pb-3">
          <span class="color-gray font-weight-normal font-14">Número de Seguro Social:</span>
          <div class="color-dark font-weight-normal font-16">
            {{ data.socialSecurityNumber }}
          </div>
        </div>
        <div v-if="isAssistance || isMaster" class="col-sm-6 col-md-4 pb-3">
          <span class="color-gray font-weight-normal font-14">Categoría:</span>
          <div class="color-dark font-weight-normal font-16">
            {{ data.category }}
          </div>
        </div>
        <div v-if="isSpecialist" class="col-sm-6 col-md-2 pb-3">
          <span class="color-gray font-weight-normal font-14">Disciplina:</span>
          <div class="color-dark font-weight-normal font-16">
            {{ data.disciplineType }}
          </div>
        </div>
        <div class="col-sm-6 col-md-2 pb-3">
          <span class="color-gray font-weight-normal font-14">Calificación:</span>
          <div class="color-dark font-weight-normal font-16">
            {{ data.qualification }}
          </div>
        </div>
        <div v-if="isSpecialist" class="col-sm-6 col-md-5 pb-3">
          <span class="color-gray font-weight-normal font-14">Corporación:</span>
          <div class="color-dark font-weight-normal font-16">
            {{ data.company }}
          </div>
        </div>
      </div>    
    </div>   
  </div>
</template>

<script>
import edenPersonnelCategoryType from '@/utils/constants/edenPersonnelCategoryType'

export default {
  name: "ResultRowDetail",
  components: {

  },
  props: {
    categoryType: {
      type: Object,
      default: () => {}
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    isAssistance() {
      return this.categoryType?.id == edenPersonnelCategoryType.Assistance;
    },
    isSpecialist() {
      return this.categoryType?.id == edenPersonnelCategoryType.Specialist;
    },
    isMaster() {
      return this.categoryType?.id == edenPersonnelCategoryType.Master;
    },
    personnelNameTitle() {
      if (this.isSpecialist) {
        return "Nombre de Especialista";
      }
      if (this.isMaster) {
        return "Nombre de Maestro:";
      }
      return "Nombre del Asistente de Servicio:";
    }
  },
};
</script>

<style scoped>
@media only screen and (max-width: 768px) {
  .border-right {
    border-right: unset !important;  
    border-bottom: 1px solid #dee2e6 !important;  
  }
}

</style>